import { InputTextField } from 'forms';
import React, { ChangeEvent } from 'react';
import t from '@rcm/i18n-client';

interface Props {
  disabled: boolean;
  error: any;
  onValueChange: (value: string, oldValue: string, name: string, event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

const CreditCardNameField = ({ disabled, error, onValueChange, value }: Props) => {
  return (
    <InputTextField
      autoComplete="off"
      disabled={disabled}
      error={error}
      label={t('Name on Card')}
      name="creditCard[nameOnCard]" // Used by tests
      onValueChange={onValueChange}
      value={value}
    />
  );
};

export default CreditCardNameField;
